const toFiniteNumber = (value, fallback = 0) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

export const toPositiveIntOr = (value, fallback) => {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback
}

export const toNumberOr = (value, fallback = 0) => toFiniteNumber(value, fallback)

export const extractArrayEnvelope = (payload, options = {}) => {
  const { keys = ['items', 'results', 'data', 'lotteries', 'payments', 'notifications'] } = options

  if (Array.isArray(payload)) return payload
  if (!payload || typeof payload !== 'object') return []

  for (const key of keys) {
    if (Array.isArray(payload?.[key])) return payload[key]
  }

  return []
}

export const parsePaginationEnvelope = (payload, fallback = {}) => {
  const page = toPositiveIntOr(payload?.page, toPositiveIntOr(fallback.page, 1))
  const pageSize = toPositiveIntOr(payload?.page_size ?? payload?.pageSize, toPositiveIntOr(fallback.pageSize, 50))
  const total = toNumberOr(payload?.total ?? payload?.count, toNumberOr(fallback.total, 0))
  const hasServerPagination = Number.isInteger(Number(payload?.total)) && Number.isInteger(Number(payload?.page_size ?? payload?.pageSize))

  return {
    page,
    pageSize,
    total,
    hasServerPagination,
  }
}

export const normalizeEnvelope = (payload, options = {}) => {
  const items = extractArrayEnvelope(payload, options)
  const pagination = parsePaginationEnvelope(payload, options.fallbackPagination || {})

  return {
    items,
    ...pagination,
  }
}

export const normalizeLifecycleEntity = (value = {}) => {
  if (!value || typeof value !== 'object') {
    return {
      id: null,
      is_deleted: false,
    }
  }

  return {
    ...value,
    is_deleted: value?.is_deleted === true,
  }
}

export const sanitizePublicPayload = (value = {}) => {
  if (!value || typeof value !== 'object') return {}

  const cloned = { ...value }
  delete cloned.correlation_id
  delete cloned.correlation_ref
  delete cloned.payment_id
  delete cloned.raw

  return cloned
}

